import { apiUrl } from "../enviroments/enviroments.dev";
import { IPurchase, Purchase } from "../models/Purchase";
import { Api } from "./Api";

const target = "/purchases";
const profit = "/profit";

export class PurchaseService {
    public static getAllPurchaseToday (date:String) : Promise<Array<any>> {
        return Api.get(apiUrl(`${target}?date=${date}`)); 
    }

    public static getPurchasesByOrganizationToday (id: number, date?:String) : Promise<Array<any>> {
        let targetUrl =`${target}/organization/${id}`;
        if (date) targetUrl += `/date/${date}`;
        return Api.get(apiUrl(targetUrl)); 
    }

    public static getPurchasesByOrganization (id: number) : Promise<Array<any>> {
        return Api.get(apiUrl(`${target}/organization/${id}`)); 
    }

    public static createPurchase (payload: Purchase): Promise<any> {
        return Api.post(apiUrl(`${target}/create`),payload); 
    }

    public static updatePurchase (payload: IPurchase) {
        return Api.patch(apiUrl(`${target}/`+payload.id),{ status: payload.status });
    }

    // Status pelo owner: COMPLETED ou CANCELED (CANCELED estorna os movimentos).
    public static changeStatus (id: string, status: "COMPLETED" | "CANCELED") {
        return Api.patch(apiUrl(`${target}/${id}`), { status });
    }

    // Preview do estorno exibido no modal de confirmacao do cancelamento.
    public static getCancelPreview (id: string): Promise<any> {
        return Api.get(apiUrl(`${target}/${id}/cancel-preview`));
    }

    // range: ?date_start=YYYY-MM-DD&date_end=YYYY-MM-DD (ambos opcionais).
    public static fetchProfits (id:number, month: boolean, range?: { date_start?: string; date_end?: string }) {
        const qs = new URLSearchParams();
        if (range?.date_start) qs.set("date_start", range.date_start);
        if (range?.date_end)   qs.set("date_end", range.date_end);
        const query = qs.toString();
        return Api.get(apiUrl(`${profit}/${id}/${month}${query ? "?" + query : ""}`));
    }

}
